import { Component, OnInit } from '@angular/core';
import { MbDialogHeader, MbDialogBody } from '@am/moebius';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';

@Component({
    selector: 'app-modal-image-message',
    standalone: true,
    imports: [MbDialogHeader, MbDialogBody],
    templateUrl: './image-message.component.html'
})
export class ModalImageMessageComponent extends DialogWrapperComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
